import MoneyArrowColor from './MoneyArrowColour.svg';
import MoneyArrowDark from './MoneyArrowDark.svg';
import MoneyArrowLight from './MoneyArrowLight.svg';
export const moneyArrow = {
    color: MoneyArrowColor,
    dark: MoneyArrowDark,
    light: MoneyArrowLight
};
//# sourceMappingURL=index.js.map